<template>

  <!-- app-header -->
  <header class="app-header">
    <!-- Start::main-header-container -->
    <div class="main-header-container container-fluid">

      <!-- Start::header-content-left -->
      <div class="header-content-left">

        <!-- Start::header-element -->
        <div class="header-element">
          <div class="horizontal-logo">
            <NuxtLink  to='/' class="header-logo">
              <img src="/images/brand-logos/desktop-logo.png" alt="logo" class="desktop-logo">
              <img src="/images/brand-logos/toggle-logo.png" alt="logo" class="toggle-logo">
              <img src="/images/brand-logos/desktop-dark.png" alt="logo" class="desktop-dark">
              <img src="/images/brand-logos/toggle-dark.png" alt="logo" class="toggle-dark">
              <img src="/images/brand-logos/desktop-white.png" alt="logo" class="desktop-white">
              <img src="/images/brand-logos/toggle-white.png" alt="logo" class="toggle-white">
            </NuxtLink>
          </div>
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <div class="header-element">
          <!-- Start::header-link -->
          <a @click="ToggleMenu" aria-label="Hide Sidebar" class="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle" href="javascript:void(0);"><span></span></a>
          <!-- End::header-link -->
        </div>
        <!-- End::header-element -->

      </div>
      <!-- End::header-content-left -->

      <!-- Start::header-content-right -->
      <div class="header-content-right">

        <!-- Start::header-element -->
        <!--        <div class="header-element header-search">-->
        <!--          &lt;!&ndash; Start::header-link &ndash;&gt;-->
        <!--          <a href="javascript:void(0);" class="header-link" data-bs-toggle="modal" data-bs-target="#searchModal">-->
        <!--            <i class="bx bx-search-alt-2 header-link-icon"></i>-->
        <!--          </a>-->
        <!--          &lt;!&ndash; End::header-link &ndash;&gt;-->
        <!--        </div>-->
        <!-- End::header-element -->



        <!-- Start::header-element (centre de notifications étudiant — microservice push : cours créés, etc.) -->
        <!-- Masqué si studentPushNotificationsEnabled=false (nuxt.config / NUXT_PUBLIC_STUDENT_PUSH_NOTIFICATIONS) -->
        <div class="header-element notifications-dropdown" v-if="isAuthenticated && profileStore.isStudent && notificationsStore.studentPushNotificationsEnabled">
          <a
            href="javascript:void(0);"
            class="header-link dropdown-toggle"
            data-bs-toggle="dropdown"
            data-bs-auto-close="true"
            id="messageDropdown"
            aria-expanded="false"
          >
            <i class="bx bx-bell header-link-icon"></i>
            <span v-if="notificationsStore.unreadCount > 0" class="badge bg-secondary rounded-pill header-icon-badge pulse pulse-secondary" id="notification-icon-badge">
              {{ notificationsStore.unreadCount > 99 ? '99+' : notificationsStore.unreadCount }}
            </span>
          </a>
          <div class="main-header-dropdown dropdown-menu dropdown-menu-end" data-popper-placement="none">
            <div class="p-3">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex flex-column">
                  <p class="mb-0 fs-16 fw-semibold">Notifications</p>
                  <small class="text-muted">Aperçu</small>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <span v-if="notificationsStore.unreadCount > 0" class="badge bg-primary-transparent text-primary" id="notifiation-data">
                    {{ notificationsStore.unreadCount }} non lue{{ notificationsStore.unreadCount > 1 ? 's' : '' }}
                  </span>
                  <button
                    v-if="notificationsStore.unreadCount > 0"
                    type="button"
                    class="btn btn-sm btn-light"
                    @click="markAllPreviewRead"
                    title="Tout marquer comme lu"
                  >
                    Tout marquer comme lu
                  </button>
                </div>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <ul v-if="notificationsStore.loading" class="list-unstyled mb-0 p-3">
              <li class="text-muted text-center">Chargement...</li>
            </ul>
            <div v-else-if="notificationsStore.previewList.length" class="mydit-notif-dropdown">
              <ul class="list-unstyled mb-0 notification-container" id="header-notification-scroll">
                <li v-for="item in notificationsStore.previewList" :key="item.slug" class="dropdown-item">
                  <NuxtLink
                    :to="notificationLink(item)"
                    class="mydit-notif-row d-flex align-items-start gap-2 p-2 rounded-2 text-reset text-decoration-none"
                    @click="handleNotificationClick(item)"
                  >
                    <span
                      class="avatar avatar-md avatar-rounded flex-shrink-0"
                      :class="item.status !== 'READ' ? 'bg-primary-transparent' : 'bg-secondary-transparent'"
                    >
                      <i class="fs-18 ti ti-school"></i>
                    </span>
                    <div class="flex-grow-1 min-w-0">
                      <div class="d-flex align-items-start justify-content-between gap-2">
                        <div class="min-w-0">
                          <div class="d-flex align-items-center gap-2">
                            <span v-if="item.status !== 'READ'" class="mydit-unread-dot" aria-label="Non lue"></span>
                            <p class="mb-0 fw-semibold text-truncate">
                              {{ item.title || 'Notification' }}
                            </p>
                          </div>
                          <p class="mb-0 text-muted fw-normal fs-12 header-notification-text text-wrap">
                            {{ item.content || item.title }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </NuxtLink>
                </li>
              </ul>
              <div class="mydit-notif-footer border-top p-2">
                <NuxtLink to="/admin/notifications" class="btn btn-primary-light w-100 d-flex align-items-center justify-content-center gap-2">
                  <i class="ti ti-list-details"></i>
                  <span>Voir tout</span>
                </NuxtLink>
              </div>
            </div>
            <div v-if="!notificationsStore.loading && !notificationsStore.previewList.length" class="p-5 empty-item1">
              <div class="text-center">
                <span class="avatar avatar-xl avatar-rounded bg-secondary-transparent">
                  <i class="ri-notification-off-line fs-2"></i>
                </span>
                <h6 class="fw-semibold mt-3">Pas de nouvelle notification</h6>
                <NuxtLink to="/admin/notifications" class="btn btn-sm btn-outline-primary mt-2">Voir le centre</NuxtLink>
              </div>
            </div>
          </div>
        </div>
        <!-- End::header-element -->


        <!-- Start::header-element -->
        <div class="header-element header-fullscreen">
          <!-- Start::header-link -->
          <a @click="toggleFullScreen();" href="javascript:void(0);" class="header-link">
            <i v-if="!isFullScreen" class="bx bx-fullscreen full-screen-open header-link-icon"></i>
            <i v-if="isFullScreen" class="bx bx-exit-fullscreen full-screen-close header-link-icon"></i>
          </a>
          <!-- End::header-link -->
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <v-menu v-if="isAuthenticated" class="header-element" transition="slide-y-transition">
          <!-- Start::header-link|dropdown-toggle -->
          <template v-slot:activator="{ props }">
            <a href="javascript:void(0);" class="header-link dropdown-toggle" id="mainHeaderProfile" v-bind="props">
              <div class="d-flex align-items-center">
                <div class="me-sm-2 me-0">
                  <v-avatar size="32" class="mb-3">
                    <v-img v-if="profileStore.avatarUrl" :src="profileStore.avatarUrl" alt="Avatar"></v-img>
                    <v-icon v-else size="32" color="primary">mdi-account</v-icon>
                  </v-avatar>
                  <!-- <img
                      :src="profileStore.avatarUrl"
                      alt="img"
                      width="32"
                      height="32"
                      class="rounded-circle"
                  > -->
                </div>
                <div class="d-sm-block d-none">
                  <p class="fw-semibold mb-0 lh-1">
                    <span v-if="profileStore.loading">Chargement...</span>
                    <span v-else-if="profileStore.error" class="text-danger">Erreur</span>
                    <span v-else-if="profileStore.fullName">{{ profileStore.fullName }}</span>
                    <span v-else>Chargement...</span>
                  </p>
                  <span class="op-7 fw-normal d-block fs-11">
                    <span v-if="profileStore.loading">...</span>
                    <span v-else-if="profileStore.error" class="text-danger">Erreur de chargement</span>
                    <span v-else-if="profileStore.userTypeLabel">{{ profileStore.userTypeLabel }}</span>
                    <span v-else>...</span>
                  </span>
                  <!-- Debug info -->
                  <!-- <small class="text-muted d-block" v-if="profileStore.userType">
                    Type: {{ profileStore.userType }}
                  </small> -->
                </div>
              </div>
            </a>
          </template>
          <!-- End::header-link|dropdown-toggle -->
          <v-list class="main-header-dropdown pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end" aria-labelledby="mainHeaderProfile">
            <v-list-item>
              <NuxtLink :to="mapPath('/pages/profile')" class="dropdown-item d-flex">
                <i class="ti ti-user-circle fs-18 me-2 op-7"></i>Profile
              </NuxtLink>
            </v-list-item>
            <v-list-item>
              <a @click.prevent="logout" class="dropdown-item d-flex" href="#" style="cursor: pointer;">
                <i class="ti ti-logout fs-18 me-2 op-7"></i>Déconnexion
              </a>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- End::header-element -->



      </div>
      <!-- End::header-content-right -->

    </div>
    <!-- End::main-header-container -->
  </header>
  <!-- /app-header -->


  <div class="modal fade" id="searchModal" tabindex="-1" aria-labelledby="searchModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="input-group">
            <a href="javascript:void(0);" class="input-group-text" id="Search-Grid"><i class="fe fe-search header-link-icon fs-18"></i></a>
            <input type="search" class="form-control border-0 px-2" placeholder="Search" aria-label="Username">
            <a href="javascript:void(0);" class="input-group-text" id="voice-search"><i class="fe fe-mic header-link-icon"></i></a>
            <a href="javascript:void(0);" class="btn btn-light btn-icon" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="fe fe-more-vertical"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="javascript:void(0);">Action</a></li>
              <li><a class="dropdown-item" href="javascript:void(0);">Another action</a></li>
              <li><a class="dropdown-item" href="javascript:void(0);">Something else here</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" href="javascript:void(0);">Separated link</a></li>
            </ul>
          </div>
          <div class="mt-4">
            <p class="font-weight-semibold text-muted mb-2">Are You Looking For...</p>
            <span class="search-tags"><i class="fe fe-user me-2"></i>People<a href="javascript:void(0)" class="tag-addon"><i class="fe fe-x"></i></a></span>
            <span class="search-tags"><i class="fe fe-file-text me-2"></i>Pages<a href="javascript:void(0)" class="tag-addon"><i class="fe fe-x"></i></a></span>
            <span class="search-tags"><i class="fe fe-align-left me-2"></i>Articles<a href="javascript:void(0)" class="tag-addon"><i class="fe fe-x"></i></a></span>
            <span class="search-tags"><i class="fe fe-server me-2"></i>Tags<a href="javascript:void(0)" class="tag-addon"><i class="fe fe-x"></i></a></span>
          </div>
          <div class="my-4">
            <p class="font-weight-semibold text-muted mb-2">Recent Search :</p>
            <div class="p-2 border br-5 d-flex align-items-center text-muted mb-2 alert">
              <NuxtLink to="#"><span>Notifications</span></NuxtLink>
              <a class="ms-auto lh-1" href="javascript:void(0);" data-bs-dismiss="alert" aria-label="Close"><i class="fe fe-x text-muted"></i></a>
            </div>
            <div class="p-2 border br-5 d-flex align-items-center text-muted mb-2 alert">
              <NuxtLink to="#"><span>Alerts</span></NuxtLink>
              <a class="ms-auto lh-1" href="javascript:void(0);" data-bs-dismiss="alert" aria-label="Close"><i class="fe fe-x text-muted"></i></a>
            </div>
            <div class="p-2 border br-5 d-flex align-items-center text-muted mb-0 alert">
              <NuxtLink to="#"><span>Mail</span></NuxtLink>
              <a class="ms-auto lh-1" href="javascript:void(0);" data-bs-dismiss="alert" aria-label="Close"><i class="fe fe-x text-muted"></i></a>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="btn-group ms-auto">
            <button class="btn btn-sm btn-primary-light">Search</button>
            <button class="btn btn-sm btn-primary">Clear Recents</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { nextTick, computed, watch, onMounted } from 'vue';
import { switcherStore } from '@/stores/switcher';
import { useAuthStore } from '@/stores/auth'; // import the auth store we just created
import { useDjangoAssets } from "~/composables/useDjangoAssets";
import { useProfileStore } from '@/stores/profile';
import { useNotificationsStore } from '@/stores/notifications';

export default {
  setup() {
    const switcher = switcherStore();
    const { mapPath } = usePath()

    const profileStore = useProfileStore();
    const authStore = useAuthStore();
    const notificationsStore = useNotificationsStore();
    const colorthemeFn = value => { localStorage.setItem('ynexcolortheme', value); switcher.colorthemeFn(value) };
    const router = useRouter();
    const token = useCookie('token');

    // Vérifier si l'utilisateur est authentifié
    const isAuthenticated = computed(() => {
      return authStore.authenticated && !!token.value && !!profileStore.profile;
    });

    const { logout: authLogout } = useAuth(); // use logout from useAuth composable

    const logout = async () => {
      // Nettoyer d'abord l'authentification et le profil
      authLogout();

      // Attendre un tick pour s'assurer que le nettoyage est terminé
      await nextTick();

      // Rediriger vers la page de login avec replace pour éviter les problèmes de navigation
      await router.replace('/auth/login');
    };

    const studentSlug = computed(() =>
      profileStore.isStudent && profileStore.profile?.etudiant?.slug
        ? profileStore.profile.etudiant.slug
        : null
    );

    onMounted(async () => {
      try {
        const token = useCookie('token');
        if (token.value && !profileStore.profile) {
          await profileStore.fetchProfile();
        }
      } catch (error) {
      }
    });

    watch(
      [studentSlug, () => profileStore.profile, () => notificationsStore.studentPushNotificationsEnabled],
      ([slug]) => {
        if (slug && notificationsStore.studentPushNotificationsEnabled && notificationsStore.isConfigured) {
          notificationsStore.load(slug);
          notificationsStore.startPolling(slug, { pollMs: 25000, showToast: true });
        } else if (!slug || !notificationsStore.studentPushNotificationsEnabled) {
          notificationsStore.clear();
        }
      },
      { immediate: true }
    );

    return {
      switcher,
      profileStore,
      notificationsStore,
      studentSlug,
      colorthemeFn,
      logout,
      mapPath,
      isAuthenticated
    }
  },
  data() {
    return {
      isFullScreen: false,
    }
  },
  methods: {
    ToggleMenu() {
      let html = document.querySelector('html');
      if (window.innerWidth <= 992) {
        let dataToggled = html.getAttribute('data-toggled');
        if (dataToggled == 'open') {
          html.setAttribute('data-toggled', 'close');
        } else {
          html.setAttribute('data-toggled', 'open');
        }
      } else {
        let menuNavLayoutType = html.getAttribute('data-nav-style');
        let verticalStyleType = html.getAttribute('data-vertical-style');
        if (menuNavLayoutType) {
          let dataToggled = html.getAttribute('data-toggled');
          if (dataToggled) {
            html.removeAttribute('data-toggled');
          } else {
            html.setAttribute('data-toggled', menuNavLayoutType + '-closed');
          }
        } else if (verticalStyleType) {
          let dataToggled = html.getAttribute('data-toggled');
          if (verticalStyleType == 'doublemenu') {
            if (html.getAttribute('data-toggled') === 'double-menu-open' && document.querySelector('.double-menu-active')) {
              html.setAttribute('data-toggled', 'double-menu-close');
            } else {
              if (document.querySelector('.double-menu-active')) {
                html.setAttribute('data-toggled', 'double-menu-open');
              }
            }
          } else if (dataToggled) {
            html.removeAttribute('data-toggled');
          } else {
            switch (verticalStyleType) {
              case 'closed':
                html.setAttribute('data-toggled', 'close-menu-close');
                break;
              case 'icontext':
                html.setAttribute('data-toggled', 'icon-text-close');
                break;
              case 'overlay':
                html.setAttribute('data-toggled', 'icon-overlay-close');
                break;
              case 'detached':
                html.setAttribute('data-toggled', 'detached-close');
                break;
            }
          }
        }
      }
    },
    toggleFullScreen() {
      const element = document.documentElement; // Full-screen target element

      if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement) {
        // If in full-screen mode, exit it
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      } else {
        // If not in full-screen mode, enter it
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      }
    },
    async handleNotificationClick(item) {
      if (item.status !== 'READ') {
        await this.notificationsStore.markRead(item.slug);
      }
    },
    handleRemoveNotification(item) {
      this.notificationsStore.remove(item.slug);
    },
    notificationLink(item) {
      return '/admin/notifications';
    },
    formatNotifTime(iso) {
      if (!iso) return '';
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return '';
      // format court, cohérent avec le header
      return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
    },
    async markAllPreviewRead() {
      const unread = (this.notificationsStore.previewList || []).filter((n) => n.status !== 'READ');
      // Best-effort: pas besoin de bloquer l'UI.
      await Promise.all(unread.map((n) => this.notificationsStore.markRead(n.slug)));
    },

    fullscreenchanged() {
      if (document.fullscreenElement) {
        this.isFullScreen = true;
      } else {
        this.isFullScreen = false;
      }
    }
  },
  mounted() {
    document.addEventListener("fullscreenchange", this.fullscreenchanged);
  },
}
</script>
<style>
.mydit-notif-dropdown {
  display: flex;
  flex-direction: column;
}

.mydit-notif-footer {
  position: sticky;
  bottom: 0;
  background: var(--body-bg, var(--bs-body-bg, #fff));
  z-index: 2;
}

.mydit-notif-row:hover {
  background: rgba(var(--primary-rgb), 0.045);
}

.mydit-unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--primary-color);
  display: inline-block;
  flex-shrink: 0;
}

/* Fix rendu “découpé” : on laisse le dropdown gérer son arrondi + on clippe proprement */
.main-header-container .notifications-dropdown .main-header-dropdown {
  overflow: hidden;
  border-radius: var(--default-border, 0.5rem);
}

.mydit-notif-footer .btn {
  border-radius: 0.5rem;
}

/* Évite un “débordement” sur la droite avec certains fonts/sizes */
.mydit-notif-row {
  width: 100%;
}
</style>